// Maker Embed Script
(function() {
    // Create container if not exists
    function createContainer() {
        const container = document.createElement('div');
        container.id = 'hgp2q6wr2bc2umrui43eiies-root';
        container.className = 'hgp2q6wr2bc2umrui43eiies-app makerai-app';

        // Find the script tag
        const currentScript = document.currentScript;
        if (currentScript && currentScript.parentNode && currentScript.parentNode !== document.head) {
            currentScript.parentNode.insertBefore(container, currentScript);
        } else {
            document.body.appendChild(container);
        }
        return container;
    }

    function addMadeWithMakerLink(container) {
     return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = 'https://ai.maker.co';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.position = 'sticky';
        link.style.bottom = '8px';
        link.style.right = '8px';
        link.style.left = '8px';
        link.style.textDecoration = 'none';
        link.style.zIndex = '9999';
        link.style.display = 'block';
        link.style.height = '24px';
        link.style.width = 'fit-content';
        link.style.lineHeight = '24px';
        link.style.padding = '0 8px';
        link.style.borderRadius = '6px';
        link.style.backgroundColor = 'rgba(0, 0, 0, 0.60)';
        link.style.backdropFilter = 'blur(2px)';
        link.style.color = '#FFF';
        link.style.fontFamily = 'sans-serif';
        link.style.fontSize = '12px';
        link.style.fontWeight = '500';
        link.textContent = 'Made with maker';
        container.appendChild(link);
        resolve();
      });
    }

    // Load CSS file
    function loadCSS(href) {
        return new Promise((resolve, reject) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.onload = resolve;
            link.onerror = resolve;
            document.head.appendChild(link);
        });
    }
    // Add custom style to head
    function addCustomStyle(css) {
        return new Promise((resolve, reject) => {
            const style = document.createElement('style');
            style.type = 'text/css';
            style.textContent = css;
            document.head.appendChild(style);
        });
    }

    // Load script and wait for it to be ready
    function loadScript(src, external = false, is_async = false, attrs = {}) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'module';
            script.src = src;           
            Object.entries(attrs).forEach(function(entry) {
              script.setAttribute(entry[0], entry[1]);
            });
            script.onload = () => {
                // Wait a small amount of time to ensure the script has executed
                setTimeout(resolve, 100);
            };
            script.onerror = reject;
            if (external) {
              script.type = 'text/javascript';
              document.head.appendChild(script);
            }else {
              document.body.appendChild(script);
            }
            if (is_async) {
              script.async = true;
            }
        });
    }

    function loadInlineScripts(type, scriptContent, tagName) {
      return new Promise((resolve, reject) => {
        try {
          const script = document.createElement(tagName);
          if (tagName == 'script') {
              script.type = type;
          }
          script.textContent = scriptContent;
          document.body.appendChild(script);
          // inline scripts execute immediately upon append; resolve on next tick
          setTimeout(resolve, 0);
        } catch (e) {
          reject(e);
        }
      });
    }

    // Initialize
    async function init() {
        // Get base URL from current script
        const scriptElement = document.currentScript;
        const baseUrl = scriptElement.src.split('/embed.js')[0];

        try {
            // For AB experiment: load posthog script first to ensure any tracking in inline scripts works
            await loadInlineScripts("text/javascript", `
      !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init Rr Mr fi Or Ar ci Tr Cr capture Mi calculateEventProperties Lr register register_once register_for_session unregister unregister_for_session Hr getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Ur jr createPersonProfile zr kr Br opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Dr debug M Nr getPageViewId captureTraceFeedback captureTraceMetric $r".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
                posthog.init('phc_qbDTSuJCBxyX8CACLOEhPNZBvJVcELuLXGG6J2ibUmK', {
                    api_host: 'https://us.i.posthog.com',
                    defaults: '2025-05-24',
                    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
                    name: 'ph_devi_hgp2q6wr2bc2umrui43eiies',
                    autocapture: {
                      css_selector_allowlist: [
                        '[data-tracking-id]'
                      ]
                    },
                    loaded: function(posthog) {
                      posthog.register({
                        mkr_product: 'devi',
                        mkr_project_id: 'hgp2q6wr2bc2umrui43eiies',
                        mkr_org_id: 'org_2RBkUqh3LVjYlDQLDGXc6cEkFC7',
                        mkr_organization_name: 'unknown',
                        mkr_version: 1772255884632
                      });
                      
  var _instanceName = 'ph_devi_hgp2q6wr2bc2umrui43eiies';
  window.__mkr_ph = window.__mkr_ph || {};
  window.__mkr_ph[_instanceName] = { distinctId: posthog.get_distinct_id(), buckets: {} };
  console.log("PostHog instance 'ph_devi_hgp2q6wr2bc2umrui43eiies' is ready with distinct ID:", window.__mkr_ph[_instanceName].distinctId);
  document.dispatchEvent(new CustomEvent('mkr:ph:ready', { detail: { instanceName: _instanceName, distinctId: window.__mkr_ph[_instanceName].distinctId } }));

                    },
                });
                
  window.__mkr_ph = window.__mkr_ph || {};
  window.__mkr_ph_bucket = function(seed, instanceName) {
    instanceName = instanceName || 'ph_devi_hgp2q6wr2bc2umrui43eiies';

    var _resolve = function(distinctId) {
      if (!distinctId) return null;

      var state = window.__mkr_ph[instanceName];
      if (!state) return null;

      state.buckets = state.buckets || {};

      // return cached bucket
      if (state.buckets[seed] !== undefined) {
        return state.buckets[seed];
      }

      // FNV-1a hash
      var hash = 0x811c9dc5;
      var combined = seed + ':' + distinctId;

      for (var i = 0; i < combined.length; i++) {
        hash ^= combined.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
      }

      var bucket = (hash >>> 0) % 10000;

      state.buckets[seed] = bucket;

      return bucket;
    };

    var state = window.__mkr_ph[instanceName];

    // state ready
    if (state && state.distinctId !== undefined) {
      return Promise.resolve(_resolve(state.distinctId));
    }

    // deduplicate waiters per instance - one listener, one Promise, shared across all callers
    if (!window.__mkr_ph_waiters) window.__mkr_ph_waiters = {};
    if (window.__mkr_ph_waiters[instanceName]) return window.__mkr_ph_waiters[instanceName];

    window.__mkr_ph_waiters[instanceName] = new Promise(function(resolve) {
      var handler = function(e) {
        if (e.detail.instanceName === instanceName) {
          document.removeEventListener('mkr:ph:ready', handler);
          delete window.__mkr_ph_waiters[instanceName];
          resolve(_resolve(e.detail.distinctId));
        }
      };
      document.addEventListener('mkr:ph:ready', handler);
    });

    return window.__mkr_ph_waiters[instanceName];
  };

                
  window.__mkr_ph_resolve_variant = function(exp, instanceName) {
    instanceName = instanceName || 'ph_devi_hgp2q6wr2bc2umrui43eiies';
    var rolloutThreshold = exp.rolloutPer * 100;
    return window.__mkr_ph_bucket(exp.name, instanceName).then(function(bucket) {
      if (bucket === null || bucket >= rolloutThreshold) return null;
      var variant = null;
      for (var i = 0; i < exp.variants.length; i++) {
        var v = exp.variants[i];
        if (bucket >= v.start && bucket <= v.end) { variant = v.variant; break; }
      }
      if (variant === null) return null;
      posthog.capture('variant_captured', { experiment: exp.name, bucket: bucket, variant: variant });
      return variant;
    });
  };

  // sample usage
  var __mkr_sample_exp = {
    name: 'exp_hgp2q6wr2bc2umrui43eiies',
    rolloutPer: 60,
    variants: [
      { variant: 0, start: 0,    end: 1499 },
      { variant: 1, start: 1500, end: 2999 },
      { variant: 2, start: 3000, end: 4499 },
      { variant: 3, start: 4500, end: 5999 }
    ]
  };
  window.__mkr_ph_resolve_variant(__mkr_sample_exp).then(function(variant) {
    console.log('[maker] sample experiment variant:', variant);
  });

  `, "script");

            // Create container
            const container = createContainer();

            // Load styles
            await Promise.all([
                loadCSS(`${baseUrl}/assets/main.css`)
            ]);

            // Load the main script and wait for it to be ready
            await loadScript(`${baseUrl}/assets/main.js`, false, true);

            // Add the Made with Maker link
            
            // Load any external scripts specified in the index.html
            
            // Load inline scripts from index.html
                      
            // Now that both container and script are ready, trigger DOMContentLoaded
            // This ensures main.jsx's DOMContentLoaded handler will find the container
            const domContentLoadedEvent = new Event('DOMContentLoaded');
            document.dispatchEvent(domContentLoadedEvent);

        } catch (error) {
            console.error('Failed to load devi widget:', error);
        }
    }

    // Run initialization
    init();
})();